<template>
  <v-dialog v-model="dialog" width="800">
    <v-card id="product-card" v-if="item">
        <v-toolbar dark color=primary>
          <v-toolbar-title>
            {{item.title}}
          </v-toolbar-title>
          <v-spacer/>
          <v-btn icon dark @click="closeProduct">
              <v-icon>mdi-close</v-icon>
          </v-btn>
      </v-toolbar>
      <v-layout column>
        <v-layout row style="margin:20px;"> 
          <v-flex xs6>
            <v-sheet elevation=5 id="product-img">
              <v-carousel v-if="item.images" height="300">
                <v-carousel-item
                  v-for="(img,i) in item.images"
                  :key="i"
                  :src="img"
                  reverse-transition="fade-transition"
                  transition="fade-transition"
                ></v-carousel-item>
              </v-carousel>
              <v-img v-else :src="item.image_url"  />
            </v-sheet>
          </v-flex>
          <v-flex xs5 offset-xs1 align-center>
            <v-card-text id="item-title" class="headline">
              {{item.title}}
            </v-card-text>
            
            <v-card-text id="item-description" class="body-1">
              {{item.description}}
            </v-card-text>

            <v-card-text id="item-price" class="subtitle-1 font-italic">
              Starting at {{item.wholesale_price_str}}
            </v-card-text>
          </v-flex>
        </v-layout>
        <v-divider style="margin: 20px;" />
        
        <v-layout row justify-center >
          <!-- Variant View -->
          <v-flex>
            <v-card-text> Your Selection </v-card-text>
          </v-flex>
          <v-flex>
            <v-card-text> Choose {{headers[choicePosition]}} </v-card-text>
          </v-flex>
        </v-layout>
        <v-layout row align-center justify-center style="margin-left:50px; margin-right:50px;">
          <!-- Variant View -->
          <v-flex xs6>
            <div id='choice-table' class="body-1" v-if="!customOverride">
              <v-layout row>
                <v-layout column>
                  <div v-for='n in Number(item.variants.depth)' :key='n'>
                    <span v-if="(n-1) == choicePosition" class="font-weight-medium quaternary--text">{{headers[n-1]}}:</span>
                    <span v-else class="font-weight-light black--text">{{headers[n-1]}}:</span>
                  </div>
                </v-layout>
                <v-layout column>
                  <div v-for='n in Number(item.variants.depth)' :key='n'>
                    <span v-if="(n-1) == choicePosition" class="font-weight-medium quaternary--text">{{choices[n-1]}} </span>
                    <span v-else class="font-weight-light black--text">{{choices[n-1]}} </span>
                  </div>
                </v-layout>
              </v-layout>
            </div>
              <!-- {{choices}} -->
            
            <!-- <v-radio-group v-model="choices[0]" :mandatory="true">
              <span v-for="(choice, index) in mainVariants" :key="index">
                <v-radio 
                  :label="choice"
                  :value="choice" >
                </v-radio>
              </span>
            </v-radio-group> -->
          </v-flex>
          <v-flex xs5 offset-xs1>
            <v-overflow-btn
              class="my-2"
              :items="currentOptions"
              :label="headers[choicePosition]"
              v-model="choices[choicePosition]"
              autofocus
              hide-details
              editable
            ></v-overflow-btn>
            <v-layout row v-if="!customOverride">
              <v-layout column justify-center align-center>
                <font class="secondary--text">{{headers[choicePosition - 1]}}</font>
                <v-btn 
                  dark 
                  rounded 
                  icon
                  color="secondary" 
                  @click="previousChoice" 
                  :disabled="choicePosition == 0"
                >
                  <v-icon> mdi-arrow-left </v-icon>
                </v-btn>
              </v-layout>
              <v-layout column justify-center align-center>
                <font class="secondary--text">{{headers[choicePosition + 1]}}</font>
                <v-btn 
                  dark 
                  rounded 
                  icon
                  color="secondary" 
                  @click="nextChoice" 
                  :disabled="choicePosition >= (item.variants.depth - 1)"
                >
                  <v-icon> mdi-arrow-right </v-icon>
                </v-btn>
              </v-layout>
            </v-layout>
            <div v-else>
              <v-text-field
                placeholder="Describe Other"
                label="Other Description"
                v-model="choices[1]"
              ></v-text-field>
            </div>
          </v-flex>
        </v-layout>
        
      </v-layout>
      <v-divider style="margin:20px" />
      <v-card-actions>
        <v-layout row align-center justify-center>
          <v-flex xs5>
            <div class="title"> 
              <font class="caption">Price per Unit</font><br>{{variantPrice ? '$'+variantPrice.toFixed(2) : 'Select ' + headers[choicePosition]}}
            </div>
          </v-flex>
          <v-flex xs2 offset-xs3 >
            <v-text-field
              solo
              label="Quantity"
              placeholder="0"
              style="width=50px"
              hide-details
              type="number"
              v-if="variantPrice || customOverride"
              v-model="quantity"
            ></v-text-field>
          </v-flex>
          <v-flex xs2>
            <v-btn dark rounded color="secondary" :disabled="!variantPrice && !customOverride" @click="submitProduct">
              {{setQuantity > 0 ? 'Update' : 'Add'}}
            </v-btn>
            <!-- <v-btn dark rounded outlined color="primary" @click="closeProduct">
              Cancel
            </v-btn> -->
          </v-flex>
        </v-layout>
      </v-card-actions>
      <!-- {{item.variants}} -->

    </v-card>
  </v-dialog>
</template>

<script>

export default {
  props: {
    debug: Boolean,
    item: Object,
    opened: Boolean,
    setChoices: Array,
    setQuantity: String,
  },
  data () {
    return {
      choicePosition: 0, 
      choices: [],
      variantPrice: null,
      quantity: 0,
      depth: 0,
      dialog: false,

    }
  },
  mounted() {
    // this.choicePosition = this.newVal.selection ? this.newVal.selection.length : 0 
    // this.variantPrice = null
    // this.quantity = this.newVal.quantity ? this.newVal.quantity : 0
    // this.choices = this.newVal.selection ? this.newVal.selection : []
  },
  computed: {
    headers: function () {
      return this.item.variants.headers
    },
    currentOptions: function () {
      let ref = this.item.variants.options
      
      if(this.customOverride) {
        return [...Object.keys(ref).sort(), 'Other']
      }

      let iter = 0
      if(this.choicePosition >= this.item.variants.common_start) {
        ref = this.item.variants.common
        iter = Number(this.item.variants.common_start)
      }
      
      for(iter; iter < this.choicePosition; iter++) {
          ref = ref[this.choices[iter]]
      }
      
      if(this.choicePosition == 0) {
        return [...Object.keys(ref).sort(), 'Other']
      } else {
        return Object.keys(ref).sort()
      }
    },
    customOverride: function () {
      return this.choices && this.choices[0] == 'Other'
    }
    
  },
  watch: {
    'item': {
      handler: function(newVal, oldVal) {
        if(this.debug) console.log('item watcher')
        if(this.debug) console.log('item is at item watcher:', this.item)
        
        if(newVal != oldVal && newVal != null) {
          this.variantPrice = null
          this.choices = this.setChoices ? this.setChoices : []
          this.choicePosition = this.setChoices.length > 0 ? this.setChoices.length-1 : 0 
          if(this.customOverride) this.choicePosition = 0
          this.quantity = this.setQuantity ? this.setQuantity : 0
          this.depth = this.setChoices[0] == 'Other' ? 0 : this.item.variants.depth

          if(this.choices.length == this.depth) this.calculateVariantPrice()
        } else if(newVal == null){
          this.resetValues()
        }
      },
      deep: true
    },
    'dialog': { // When dialog is opened
      handler: function(newVal, oldVal) {
        if(this.debug) console.log('dialog watcher')
        if(this.debug) console.log('item is at dialog watcher:', this.item)
        
        if(newVal != oldVal) {
          this.$emit('status', newVal)
          this.variantPrice = null
          this.choices = this.setChoices ? this.setChoices : []
          this.choicePosition = this.setChoices.length > 0 ? this.setChoices.length-1 : 0 
          if(this.customOverride) this.choicePosition = 0
          this.quantity = this.setQuantity ? this.setQuantity : 0
          this.depth = this.setChoices[0] == 'Other' ? 0 : this.item.variants.depth
          
          if(this.choices.length == this.item.variants.depth) this.calculateVariantPrice()
        } else if(newVal == false){
          this.resetValues()
        }
      },
      deep: true
    },
    'opened': {
      handler: function(newVal, oldVal) {
        if(this.debug) console.log('opened watcher')
        if(this.debug) console.log('item is at opened watcher:', this.item)
        
        if(newVal != oldVal) {
          this.dialog = newVal
          
        } 
      },
      deep: true
    },
    'choices': function (val) {
      if(this.debug) console.log('choice watcher')
      if(this.item) {
        if(this.customOverride) {
          this.depth = 0
        } else if(val.length == this.depth) {
          // // console.log('checkOrder is:', this.checkOrder)
          // // console.log('checkOrder length is:', this.checkOrder.length)
          // if(this.checkOrder.length > 0) {
          //   // console.log('val is:', val)
          //   let selectedProductIndex = this.checkOrder.findIndex((element) => {
          //     return (element.title == this.item.title) && (element.selection_str) 
          //   });
          //   console.log('SelectedProductIndex is:', selectedProductIndex)
          //   if(selectedProductIndex >= 0) this.quantity = this.checkOrder[selectedProductIndex].quantity
          // }
            
          this.calculateVariantPrice()

        } else {
          this.variantPrice = null
        }
      
      }
    }
  },
  methods: {
    calculateVariantPrice() {
      this.variantPrice = this.item.wholesale_price
      if(this.customOverride) {this.variantPrice = 0; return}

      let ref = this.item.variants.options
      let iter
      for(iter = 0; iter <= this.depth; iter++) {
        // console.log('iter is:', iter)
        // console.log('variantPrice is:', this.variantPrice)
        // console.log('ref is:', ref)

        if(typeof ref[this.choices[iter]] == 'string' || typeof ref[this.choices[iter]] == 'number') {
          let amount = Number(ref[this.choices[iter]]) < 0 ? Number(ref[this.choices[iter]]) : Number(ref[this.choices[iter]]) * this.item.wholesale_rate
          
          this.variantPrice += amount
        }

        if(iter == this.item.variants.common_start) {
          ref = this.item.variants.common
        }
        ref = ref[this.choices[iter]]
        // if(Object.keys(ref) == 0) this.variantPrice += Number(ref) * this.item.wholesale_rate
      }
    },
    nextChoice: function () {
      if(this.choices[this.choicePosition]){
        if(this.choicePosition < (Number(this.item.variants.depth) - 1)) {
          this.choicePosition++
        } else {
          if(this.debug) console.log('All Choices Made!')
        }
      } else {
        if(this.debug) console.log('Please make a selection')
      }
      
      
    },
    previousChoice: function () {
      
      if(this.choicePosition > 0) {
        this.choices.pop()
        this.choicePosition--
      } else {
        this.choicePosition = 0
      }
      
    },
    submitProduct: function () {
      if(this.quantity > 0) {
        let payload = {...this.item}
        payload['selection'] = this.choices
        payload['selection_str'] = this.choices.join(', ')
        if(this.variantPrice) {
          payload['price_str'] = '$' + this.variantPrice.toFixed(2)
          payload['price'] = this.variantPrice
        } else {
          payload['price_str'] = 'Unknown'
          payload['price'] = 0
        }
        payload['quantity'] = Number(this.quantity)
        payload['total'] = this.variantPrice * Number(this.quantity)
        payload['total_str'] = '$' + payload.total.toFixed(2)
        this.$emit('update', payload)
        this.resetValues()
      } else {
        if(this.debug) console.log('Quantity must be greater than 0')
      }
      
    },
    closeProduct: function () {
      this.resetValues()
      this.$emit('close')

    },
    resetValues: function () {
      this.choicePosition = 0 
      this.variantPrice = null
      this.quantity = 0
      this.choices = []
    }
  }
}
</script>

<style scoped>

#product-img {
  width: auto;
  margin: 20px;
  border-radius: 20px;
  border-style: groove;
  border-color: #aaaaaa;
}

#product-card {
  text-align: center;
  width: 100%;
  border-radius: 10px;
  padding: 5px;
  overflow-x: hidden;
  overflow-y: auto;
}

#item-title {
  margin-top: 50px;
}

#choice-table {
  text-align: left;
  width: 100%;
  height: 100%;
}

#position-tile {
  width: 20px;
  height: 20px;
  font-size: 20px;
  text-align: center;
  text-justify: center;
  border-radius: 5px;
  border-style: inset;
  border-width: 1px;
  border-color: #eeeeee;
  color: #aaaaaa;
}

</style>